import { COUNTRY_CONFIG } from "Config/country";
import useTranslation from "next-translate/useTranslation";
import { default as NumberFormat } from "react-number-format";
import { useDispatch } from "react-redux";
import { setPrix } from "redux/slices/carteprixReducer";
import formatUrl from "utils/FormatUrl";
import { buildUrl } from "../../PrixImmoRouterUrlHelper";
import styles from "./AveragePricesTable.module.css";
let matches =
  typeof window !== "undefined" &&
  window.matchMedia("(min-width: 990px)").matches;

const isBrowser = () => typeof window !== "undefined";

export default function AveragePricesTable({
  isH1,
  type,
  titre,
  prices,
  loadingPrices,
}: {
  isH1?: boolean;
  prices: {
    _id: string;
    prix_appartement: number;
    prix_villa: number;
    province: string;
    region: string;
    commune: string;
    province_ar: string;
    indice_confiance_appartement: number;
    indice_confiance_villa: number;
    lat: number;
    lng: number;
  }[];
  titre: string;
  type: "provinces" | "communes";
  loadingPrices: boolean;
}) {
  const { t, lang } = useTranslation("prixImmobilierMaroc");
  const dispatch = useDispatch();

  return (
    <>
      <div className={styles.prix__display__container}>
        <div>
          {isH1 ? (
            <h1 className={styles.prix__info__titre__main}>
              {titre
                ? titre
                : t("Le prix du m2 dans les grandes villes du Maroc")}
            </h1>
          ) : (
            <p className={styles.prix__info__titre__main}>
              {titre
                ? titre
                : t("Le prix du m2 dans les grandes villes du Maroc")}
            </p>
          )}
        </div>
        <div
          className={styles.prices__cities__table__container}
          style={{ minHeight: `${prices.length * 30}px`, width: "100%" }}
        >
          <table
            className={styles.price__table}
            style={{ minHeight: `${prices.length * 30}px`, width: "100%" }}
          >
            <thead className={styles.price__table__head}></thead>
            <tbody>
              <tr
                className={`${styles.price__table__head__row} ${styles.price__table__head__row__name}`}
              >
                <th
                  className={`${styles.price__table__head__container} ${styles.price__table__head__row__name}`}
                >
                  {type === "communes" ? t("Commune") : t("Ville")}
                </th>

                <th className={styles.price__table__head__container}>
                  {t("Prix m² moyen Appartement")}
                </th>

                <th className={styles.price__table__head__container}>
                  {t("Prix m² moyen Villa")}
                </th>
              </tr>

              {prices.map((price) => {
                let url__ = buildUrl(
                  price.region,
                  price.province,
                  price.commune
                );
                return (
                  <tr
                    key={price._id}
                    className={styles.price__table__item__row}
                  >
                    <td
                      className={`${styles.price__table__item__container} ${styles.price__table__item__name}`}
                    >
                      <a
                        href={formatUrl(
                          buildUrl(price.region, price.province, price.commune),
                          lang
                        )}
                        rel={
                          url__.includes("list") ||
                          url__.includes("map") ||
                          url__.includes("?") ||
                          url__.includes("conditions") ||
                          url__.includes("contact")
                            ? "nofollow noopener noreferrer noindex"
                            : "follow"
                        }
                        className={styles.prices__list}
                        onClick={(e) => {
                          void 0;
                          e.preventDefault();
                          dispatch(
                            setPrix({
                              data: price,
                            })
                          );
                        }}
                      >
                        {type == "provinces"
                          ? t(price.province.replace("-Ida -Ou-Tanane", ""))
                          : t(price.commune)}
                      </a>
                    </td>
                    <td
                      className={`${styles.price__table__item__container} ${styles.price__table__item__name}`}
                      style={
                        lang == "ar"
                          ? { direction: "ltr", textAlign: "right" }
                          : null
                      }
                    >
                      <span className={styles.price__table__item}>
                        {price.prix_appartement ? (
                          <>
                            <NumberFormat
                              style={{ direction: "ltr" }}
                              displayType={"text"}
                              value={parseInt(`${price.prix_appartement}`)}
                              thousandSeparator={" "}
                            />
                            {` ${t(
                              COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY]
                                .CURRENCY
                            )}`}
                          </>
                        ) : (
                          " - "
                        )}
                      </span>
                    </td>
                    <td
                      className={`${styles.price__table__item__container} ${styles.price__table__item__name}`}
                      style={
                        lang == "ar"
                          ? { direction: "ltr", textAlign: "right" }
                          : null
                      }
                    >
                      <span className={styles.price__table__item}>
                        {price.prix_villa ? (
                          <>
                            <NumberFormat
                              displayType={"text"}
                              value={parseInt(`${price.prix_villa}`)}
                              thousandSeparator={" "}
                            />
                            {` ${t(
                              COUNTRY_CONFIG[process.env.NEXT_PUBLIC_COUNTRY]
                                .CURRENCY
                            )}`}
                          </>
                        ) : (
                          " - "
                        )}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      {/* )} */}
    </>
  );
}
